<template>
    <div v-if="!isEmbedded && stores && stores.length" class="store-selector-wrapper">
        <b-dropdown
            ref="storesDropdown"
            split
            variant="primary"
            :text="storeSelectorTitle"
            @click="onStoresDropdownClick()"
            @shown="resizeStoresMenu()"
        >
            <!-- All stores selector currently disabled -->
            <!-- <b-dropdown-item v-if="allowAllStoresSelector" goToAppInstallLink:active="store == null" @click="setStoreUrl(null)">
                All stores
            </b-dropdown-item> -->

            <b-dropdown-item
                v-for="store in stores"
                :key="`store-${store.Id}`"
                :value="store.Url"
                :active="$store.state.store == store.Url"
                @click="setStoreUrl(store.Url)"
            >
                <div>{{ store.Url }}</div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script setup lang="ts">
import { Ref, computed, nextTick, onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { useStore } from '@/store';
import type { BDropdown } from 'bootstrap-vue/src/components/dropdown';
import type { StoreType } from '@extTypes/api/customily/user';

const emit = defineEmits<{
    (event: 'store-selected', value: string | null): void;
}>();

const props = defineProps<{
    storeTypes?: StoreType[];
}>();

const { state, commit } = useStore();

const route = useRoute();

const isEmbedded = computed(() => route.query.embedded === 'true');

const storesDropdown: Ref<BDropdown | null> = ref(null);

/**
 * this getter maybe is unnecesary, because store always will
 * have value whenever selector is visible
 */
const storeSelectorTitle = computed(() => state.store || 'All stores');

const stores = computed(() => {
    const userStores = state.user?.customilyUser.Stores || [];
    return props.storeTypes ? userStores.filter((s) => props.storeTypes!.includes(s.Type)) : userStores;
});

onBeforeMount(() => {
    const isAvailableStore = stores.value.some((s) => s.Url == state.store);
    if (!isAvailableStore && stores.value.length) {
        commit('setStore', stores.value[0].Url);
    }
});

const onStoresDropdownClick = () => {
    storesDropdown.value?.show();
};

const setStoreUrl = (store: string | null) => {
    commit('setStore', store);
    emit('store-selected', store);
};

const resizeStoresMenu = async () => {
    await nextTick();

    const dropdown = storesDropdown.value?.$el as HTMLElement;
    const menu = dropdown.querySelector('.dropdown-menu') as HTMLElement;
    const toggle = dropdown.querySelector('[aria-haspopup="menu"]') as HTMLElement;
    const boundary = dropdown.closest('.child-view') as HTMLElement;

    if (!menu || !toggle || !boundary) return;

    const boundaryRect = boundary.getBoundingClientRect();
    const toggleRect = toggle.getBoundingClientRect();
    const gap = 30;

    const spaceBelow = boundaryRect.bottom - toggleRect.bottom - gap;

    const spaceAbove = toggleRect.top - boundaryRect.top - gap;

    menu.style.maxHeight = `${Math.max(spaceAbove, spaceBelow)}px`;

    menu.style.overflowY = 'auto';
    storesDropdown.value?.updatePopper();
};
</script>

<style lang="scss" scoped>
.store-selector-wrapper {
    :deep() {
        .dropdown {
            white-space: nowrap;

            button {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 300px;
            }

            .dropdown-menu {
                max-height: 90vh;
                overflow-y: auto;
            }
        }
    }
}
</style>
